export default __webpack_public_path__ + "img/whale-579929.gif";